<template>
  <v-dialog v-model="intDialogVisible" max-width="600px" class="addValueModal addComment">
    <v-card>
      <v-card-title>
                <h3 class="primary--text formName">Onboard a new user to the Innopearl Partner+ platform</h3>
      </v-card-title>
      <v-card-text>
        <v-form class="px-3"  @submit.prevent="submit">
          <div class="row mb-3">
                    <span class="fieldTitle">Name</span>
            <div class="col-12 col-md-6">

              <input type="text" id="firsname" placeholder="Firstname" v-model="input.firstname" />
              <div class="alert alert-warning text-left mt-3 " v-if="v$.input.firstname.$errors.length > 0">
                  <div  v-for="(error, index) of v$.input.firstname.$errors" :key="index">{{ error.$message }}</div>
              </div>
            </div>
            <div class="col-12 col-md-6">
              <input type="text" id="lastname" placeholder="Lastname" v-model="input.lastname" />
              <div class="alert alert-warning text-left mt-3 " v-if="v$.input.lastname.$errors.length > 0">
                  <div  v-for="(error, index) of v$.input.lastname.$errors" :key="index">{{ error.$message }}</div>
              </div>
            </div>
          </div>
          <div class="row mb-3">
                    <span class="fieldTitle">Professional email</span>
                    <div class="col-12">
                        <input type="email" id="email" placeholder="Professional email" v-model="input.email" />
                        <div class="alert alert-warning text-left mt-3 " v-if="v$.input.email.$errors.length > 0">

                             <div  v-for="(error, index) of v$.input.email.$errors" :key="index">
                               <span v-if='error.$validator == "email"'>This email address is not valid. Please try again</span>
                               <span v-else>{{ error.$message }}</span>
                             </div>
                        </div>
                    </div>
          </div>

          <div class="row mb-3">
                    <span class="fieldTitle">Select access rights
                       <div class="tooltipd tooltip-mobile" >
                          <img :src="require('@/assets/info.svg')" alt="" class="tooltipinco">
                          <p class="tooltipcontent">
                            <span><strong>All projects:</strong> users can view, edit and manage all projects</span><br/>
                            <span><strong>Own projects:</strong>users can only view, edit, and manage their own projects </span>

                          </p>
                      </div> </span>
                    <div class="col-12">
                      <v-autocomplete v-model="input.rights" closable-chips  :items="rights" item-color="#FFF" item-title="name" item-value="value" label="Access rights" chips ></v-autocomplete>

                        <div class="alert alert-warning text-left mt-3 " v-if="v$.input.rights.$errors.length > 0">
                            <div  v-for="(error, index) of v$.input.rights.$errors" :key="index">{{ error.$message }}</div>
                        </div>
                    </div>
          </div>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn @click="close" >
              Close
            </v-btn>
            <v-btn class="addValue" @click="submit" >
              Add
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { useVuelidate } from '@vuelidate/core'
import { required, email  } from '@vuelidate/validators'


export default {
  props: {
    dialogVisible: Boolean,
    formName: String,
  },
  setup () {
     return { v$: useVuelidate() }
  },
  data () {
    return{
      input: {
        firstname: "",
        lastname:"",
        email: "",
        rights:null,
      },
      rights: [
          {
            name: "All projects",
            value : 'FullProjectAccess',
          },
          {
            name:"Own projects",
            value: "OwnProjectOnly"
          }
      ]
    }
  },
  validations () {
   return {
     input:{

       firstname: {
         required,
       },
       lastname: {
         required,
       },
       rights: {
         required,
       },
       email: { required, email } // Matches this.contact.email
     }
   }
 },
  methods:{
    async submit(){
        const isFormCorrect = await this.v$.$validate()
        console.log(this.input);
        if(isFormCorrect){
          this.$emit('newValueIsProposed',this.input)
        }

    },
    close(){
        this.$emit('close',false)
    }
  },
  computed: {
    intDialogVisible: {
      get: function () {
        if (this.dialogVisible) {
          // Some dialog initialization code could be placed here
          // because it is called only when this.dialogVisible changes
        }

        return this.dialogVisible
      },
      set: function (value) {
             if (!value) {
                this.$emit('close', value);
             }
      }
    }
  },


}
</script>

<style media="screen" scoped>
  .addValueModal .v-card{
    padding:10px;
  }
  .addValueModal .v-field__outline{
    display:none;
  }
  .formName{
    text-align: left;
    font-size: 21px;
    line-height: 25px;
    color: #3783C5;
  }
  .addValueModal button{
    border: 1px solid #3783C5;
    border-radius: 50px;
    opacity: 1;
    padding: 7px 18.5px;
    color:#3783C5;
    margin: 5px;
  }

    .addValueModal button.addValue{
      border: 1px solid #3783C5;

      background:#3783C5;
      color:#fff;
    }

    .addValueInput input{
      border: 1px solid #DDDDDD;
    }
  .addComment textarea{
    width: 100%;
margin: 0;
border: 1px solid #DDDDDD;
mask-image: none !important;
  }
  .v-card-title{
    white-space: normal !important;
  }

  .loginpage{
    padding: 50px;
  }
  .loginpage form{
    background: #FFF;
    padding: 50px;
    border-radius: 20px;
    max-width: 800px;
  margin: auto;
  }

  .loginpage form input{
    border: 1px solid #DDDDDD;
  border-radius: 2px;
  width: 100%;
  height: 40px;
  padding: 5px;
  }
  .next_step_btn,
  .next_step_btn:hover{
    background: #3783C5 0% 0% no-repeat padding-box;
    box-shadow: 0px 3px 6px #00000029;
    border: 1px solid #3783C5;
    border-radius: 50px;
    opacity: 1;
    padding: 14px 37px;
    color:#FFF;
    margin:5px;
  }

  .sidebar_logo{
    width: 180px;

  }
  .fieldTitle{
    text-align:left;
    color:#3783C5;
    text-transform: uppercase;
    font-weight: 500;
    margin-bottom: 5px;
    margin-top: 10px;
    position: relative;
  }

.tooltipd{

  display: inline-block;

}
.tooltipcontent{
  position: absolute;
    right: 0;
    bottom: -20px;
    width: 100%;
    overflow: visible;
    display: none;
    background: #FFF;
    transform: translateY(100%);
    z-index: 9999;
    text-transform: none;
    color:#000;
    padding:5px;

}
  .tooltipinco:hover ~ .tooltipcontent{
    display:block;
  }
</style>
